'use client';

import { c as _c } from "react/compiler-runtime";
import { getDeliveryMethodsList } from '../lib';
import { useMiniPdpDrawer } from './use-mini-pdp-drawer';
import { useQueryMiniPdpBase } from './use-query-mini-pdp-base';
import { useQueryMiniPdpTailored } from './use-query-mini-pdp-tailored';
export const useMiniPdpProduct = () => {
  const $ = _c(16);
  const isOpen = useMiniPdpDrawer(_temp);
  const productId = useMiniPdpDrawer(_temp2);
  const baseQuery = useQueryMiniPdpBase();
  const productData = baseQuery.data?.data;
  const defaultVariant = productData?.variants[productData.defaultSku];
  const isInvalidBase = Boolean(productData) && !defaultVariant;
  const base = isOpen && productId && productData && !isInvalidBase ? productData : null;
  let t0;
  if ($[0] !== base) {
    t0 = base ? getDeliveryMethodsList(base) : [];
    $[0] = base;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const deliveryMethodsList = t0;
  const shouldFetchTailored = Boolean(base) && deliveryMethodsList.length > 0;
  let t1;
  if ($[2] !== deliveryMethodsList || $[3] !== shouldFetchTailored) {
    t1 = shouldFetchTailored ? deliveryMethodsList : [];
    $[2] = deliveryMethodsList;
    $[3] = shouldFetchTailored;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== base) {
    t2 = base ? Object.keys(base.variants) : [];
    $[5] = base;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      deliveryMethodsList: t1,
      variantSkus: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const tailoredQuery = useQueryMiniPdpTailored(t3);
  const isBaseLoading = Boolean(isOpen && productId) && !base && !isInvalidBase && !baseQuery.isError && (baseQuery.isPending || baseQuery.isFetching);
  const isTailoredLoading = shouldFetchTailored && !tailoredQuery.data && !tailoredQuery.isError && (tailoredQuery.isPending || tailoredQuery.isFetching || tailoredQuery.isLoading);
  const isTailoredError = shouldFetchTailored && tailoredQuery.isError;
  const isUnexpectedError = baseQuery.isError || isTailoredError;
  const t4 = shouldFetchTailored && !isTailoredError ? tailoredQuery.data ?? null : null;
  const t5 = isBaseLoading || isTailoredLoading;
  const t6 = isUnexpectedError || isInvalidBase;
  let t7;
  if ($[10] !== base || $[11] !== isUnexpectedError || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = {
      base,
      tailored: t4,
      isLoading: t5,
      isError: t6,
      isUnexpectedError
    };
    $[10] = base;
    $[11] = isUnexpectedError;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
function _temp(state) {
  return state.isOpen;
}
function _temp2(state_0) {
  return state_0.productId;
}